import { ArtifactError, ArtifactStatus } from '../../../../shared/helpers/transport/cloud-api/types';

export type ArtifactRecipient = {
    role: string;
    email: string | null;
    displayName: string;
};

export enum RecipientFetchingStatus {
    NOT_FETCHED = 'NOT_FETCHED',
    FETCHING = 'FETCHING',
    FETCHED = 'FETCHED',
}

export type Artifact = {
    id?: string;
    startedAt?: string;
    stoppedAt?: string;
    amIRecipient?: boolean;
    link?: { href: string };
    recipients: ArtifactRecipient[];
    recipientFetchingStatus: RecipientFetchingStatus;
    recipientsTotal?: number;
    status?: ArtifactStatus;
    error?: ArtifactError;
};

export type LoadingArtifactsStatus = 'IN_PROGRESS' | 'ERROR' | null;
